<template>
  <div id="procedure-bar" class="procedure-bar"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["dataLst"],
  watch: {
    dataLst(val) {
      this.initBar();
    },
  },
  mounted() {
    this.initBar();
  },
  methods: {
    initBar() {
      let that = this;
      let chartDom = document.getElementById("procedure-bar");
      let myChart = this.$echarts.init(chartDom, null, { renderer: "svg" });
      let option,
        dataLst = this.dataLst;
      option = {
        grid: {
          top: 30,
          bottom: 30,
          left: 70,
          right: 80,
        },
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          formatter: (params, ticket, callback) => {
            return params.data.text + ":" + params.data.value;
          },
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          show: false,
          type: "value",
          boundaryGap: [0, 0],
        },
        yAxis: {
          axisLine: { show: false },
          axisTick: { show: false },
          data: dataLst.yAxis,
        },
        series: [
          {
            type: "bar",
            barWidth: 10,
            data: dataLst.barData,
            realtimeSort: false,
          },
        ],
      };
      option && myChart.setOption(option);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.procedure-bar {
  width: 100%;
  height: 219px;
}
</style>